export default "__VITE_ASSET__CDoqF6xy__"